// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ib-0";